import { HeatmapAreaBaseRenderer } from './HeatmapAreaBaseRenderer';
import { Rectangle } from '@shared/commons/Geometry';
import { Font, SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '../../../misc/ThemeManager';
import { HeatmapSectorRenderer } from './HeatmapSectorRenderer';
export class HeatmapIndustryRenderer extends HeatmapAreaBaseRenderer {
    constructor(industryMap, settings) {
        super();
        this._undefinedSectorName = 'Undefined industry';
        this.industryMap = industryMap;
        this.areaName = isValidString(industryMap.industryName)
            ? industryMap.industryName.toUpperCase()
            : this._undefinedSectorName.toUpperCase();
        this.settings = settings;
    }
    draw(gr, mousePoint) {
        if (!this.industryMap.Visible || this.industryMap.isSelected) {
            return;
        }
        const font = new Font(ThemeManager.getSmallFontSize(), ThemeManager.customFontFamily);
        this.setRectangles(gr);
        const isHovered = this.isHovered(mousePoint);
        const headerBackgroundBrush = new SolidBrush(isHovered
            ? ThemeManager.colors.heatmapIndustryLevelBackgroundHovered
            : this.settings.industryLevelBackgroundColor);
        const headerForegroundBrush = new SolidBrush(isHovered ? ThemeManager.colors.heatmapIndustryLevelForegroundHovered : this.settings.industryLevelFontColor);
        const backgroundBrush = new SolidBrush(this.settings.industryLevelBackgroundColor);
        gr.FillRectWithRect(backgroundBrush, this.industryMap.Rectangle);
        gr.FillRectWithRect(headerBackgroundBrush, this.industryMap.headerRectangle);
        if (this.headerTextRectangle)
            this.drawHeaderText(gr, this.areaName, font, headerForegroundBrush, this.headerTextRectangle);
    }
    drawSelection(gr, mousePoint) {
        if (!this.industryMap.Visible || this.industryMap.isSelected || !this.isHovered(mousePoint)) {
            return;
        }
        const header = this.industryMap.headerRectangle;
        const body = this.industryMap.bodyRectangle;
        const rect = new Rectangle(header.X, header.Y, header.Width, header.Height + body.Height);
        const strokeLineWidth = HeatmapSectorRenderer.HOVERWIDTH;
        const strokeOffset = strokeLineWidth / 2;
        gr.strokeStyle = ThemeManager.colors.HeatmapHeaderBackgroundHovered;
        gr.lineWidth = strokeLineWidth;
        gr.strokeRect(rect.X - strokeOffset, rect.Y - strokeOffset, rect.Width + strokeLineWidth, rect.Height + strokeLineWidth);
    }
    setRectangles(gr) {
        const headerRectangle = this.industryMap.headerRectangle;
        const fontSize = ThemeManager.getSmallFontSize();
        const font = ThemeManager.createFont(fontSize);
        const leftOffset = 8;
        const headerPaddingX = 8;
        const textWidth = gr.GetTextMetrics(this.areaName, font).width + 2 * headerPaddingX;
        this.headerTextRectangle = new Rectangle(headerRectangle.X + leftOffset, headerRectangle.Y, Math.min(textWidth, headerRectangle.Width - leftOffset), headerRectangle.Height);
    }
    isHovered(mousePoint) {
        return (!mousePoint.IsEmpty() &&
            (this.industryMap.headerRectangle.Contains(mousePoint.X, mousePoint.Y) ||
                this.industryMap.bodyRectangle.Contains(mousePoint.X, mousePoint.Y)));
    }
}
